
<div fxLayout="row"fxLayoutAlign="center center" class="disclaimer">
    <div class="nh-container">
        <mat-card>
            <h2 class="mat-h2" align="center">Terms and Conditions</h2>
            <mat-card-content>
                <p>
                    Thank you for visiting the Word & Brown® website (hereinafter, the “Website”), which is owned and
                        operated by Word & Brown Insurance Administrators, Inc. (hereinafter, “Word & Brown”; “We”; or “Our”).
                        The information included in this Website was collected from sources that are considered reliable
                        including, without limitation, rate information provided by carriers. We have not verified nor can we
                        guarantee the accuracy, timeliness or completeness of such information.
                        This website is provided on as “AS-IS” basis. Thus, it is solely your responsibility to verify any
                        information you obtain from this Website before making decisions or incurring costs based on such
                        information.
                </p>
            </mat-card-content>
            <mat-card-footer class="alternate-theme" align="center">
                <button *ngIf="!_commonService.isFromBrokerMobileApp" class="nh-custom-button" mat-stroked-button
                    (click)="cancelClick()">
                    Cancel
                </button>
                <button class="nh-custom-button" color="primary" mat-flat-button (click)="navigateByUrl()"
                    routerLinkActive="router-link-active">Accept</button>
            </mat-card-footer>
        </mat-card>
    </div>
</div>